import styled from 'styled-components';
import CustomIcon from '../_CustomIcon';

export const StyledAiBotIcon = styled(CustomIcon)`
  svg {
    fill: transparent;
  }
`;
